import { Button, Paper, Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import DynamicPersonalDetails from "./DynamicPersonalDetails";

const DynamicForm = ({ title, label }) => {
  const { register, control } = useForm();

  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "User Details Dynamic Form", // unique name for your Field Array
  });

  useEffect(() => {
    append();
  }, []);

  return (
    <div>
      <Paper elevated={1} sx={{ padding: "1.5rem" }}>
        <Typography variant="h4">{title}</Typography>
        <ul style={{ listStyleType: "none" }}>
          {fields.map((field, index) => (
            <li>
              <DynamicPersonalDetails
                register={register}
                name={title}
                remove={remove}
                label={label}
                index={index}
              />
            </li>
          ))}
          <Button
            variant="contained"
            sx={{ color: "#FFF" }}
            onClick={(e) => {
              e.preventDefault();
              append({ title: `${title}` });
            }}
          >
            + Add
          </Button>
        </ul>
      </Paper>
    </div>
  );
};

export default DynamicForm;
